<template>
<div class="col-md-9">
     <p class="form-control-static" :id="'static-' + id"><slot></slot>
    	<a @click="openItem" v-if="show"><i class="glyphicon glyphicon-share"/></a>
     	<a :href="downloadLink" v-else-if="downloadLink != null"><i class="glyphicon glyphicon-share"/></a>
     </p>
</div>
</template>

<script>
export default {
  name: "StaticInput",
  data() {
    return {
    	show: false,
    	downloadLink: null
    };
  },
  props: ["id", "openLink", "openLinkGet", "checkLinkFirst"],
  created() {
	  this.init();
  },
  methods: {

      init() {
          if(this.$slots.default[0].text) {
    		  if(this.checkLinkFirst) {
    			  axios
    		        .post(this.openLinkGet, {
    		          value: this.id
    		        })
    		        .then(response => {
    		        	if(response.data.status == true) {
    		        		this.downloadLink = this.openLink + "/"+response.data.id;
    		        	}
    		        })
    		  } else {
    			  this.show = this.openLink != undefined;
    		  }
    	  }
      },

	  openItem() {
		  axios
	        .post(this.openLinkGet, {
	          value: this.id
	        })
	        .then(response => {
	        	if(response.data.status == true) {
	        		this.$router.push({path: this.openLink + response.data.id + "/"})
	        	}
	        })
	  }
  }

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/input/StaticInput.vue